import { Vector2, Vector3 } from 'three'

export const coordsToPosition = (coords: Vector2, gridOrigin: Vector2) => {
  const newCoords = gridOrigin.clone().add(new Vector2(coords.x, coords.y))
  return new Vector3(newCoords.x, 0.0, newCoords.y)
}
// WARNING!! THIS SEEMS TO BE BUGGY
export const positionToCoords = (position: Vector3, gridOrigin: Vector2) => {
  const tempCoords = new Vector2(position.z, position.x)
  const positionCoords = gridOrigin.clone().add(tempCoords)
  return new Vector2(Math.abs(positionCoords.y), Math.abs(positionCoords.x))
}
